// 本地环境配置
module.exports = {
  title: '开发',
  baseUrl: 'xxx',
  baseApi: 'https://dev-gateway.hatelifu.club',
  APPID: 'xxx',
  APPSECRET: 'xxx',
  $cdn: 'xxx'
}